import React from "react";
import { useFormContext } from "react-hook-form";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { TextField } from "@material-ui/core";
import FormErrorMessage from "Components/Shared/FormComponents/FormErrorMessage/FormErrorMessage";
import { CreateRewardFormFields } from "../CreateRewardForm";

const MESSAGE_PLACEHOLDER = "Example: \"Job well done on Project A. Here's a little something to say thanks for your hard work!\"";

export const MessageToEmployeeField = () => {
  const { register, errors } = useFormContext<CreateRewardFormFields>();

  return (
    <FormField fieldName="Message to Employee" alignItems="flex-start">
      <TextField
        multiline
        fullWidth
        rows={4}
        placeholder={MESSAGE_PLACEHOLDER}
        variant="outlined"
        name="notes"
        inputRef={register({
          maxLength : {
            value: 100,
            message: "Message length should be less than 100 characters",
          },
        })}
      />
      <FormErrorMessage
        labelFor="notes"
        message={errors.notes?.message}
        showError={!!errors.notes}
      />
    </FormField>
  );
};
